import DevToolsMain from '@src/components/Admin/DevTools/DevToolsMain'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useUser } from '@src/providers/UserProvider'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

const DevToolsPage = () => {
  const { t } = useTranslation()
  const user = useUser()

  if (!user?.rights.canExecuteDevTools) {
    return <Navigate to="/admin" replace />
  }

  return (
    <>
      <PageHeader
        title={t('admin.devTools.pageTitle')}
        breadcrumbs={{ current: t('admin.devTools.pageTitle') }}
      />
      <PageContainer>
        <DevToolsMain />
      </PageContainer>
    </>
  )
}

export default DevToolsPage
